import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { DataProvidersResolver } from '@epicuro-next/data-providers/providers-registry';
import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { List } from '@epicuro-next/models/engagement';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@DynamicComponentRegister('dynamic-shop-the-commercial-list')
@Component({
  selector: 'epc-dynamic-elements-shop-the-commercial-list',
  templateUrl: './dynamic-elements-shop-the-commercial-list.component.html',
  styleUrls: ['./dynamic-elements-shop-the-commercial-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicElementsShopTheCommercialListComponent
  implements OnDestroy
{
  private destroy$ = new Subject<void>();
  public list$ = new BehaviorSubject<null | List>(null);

  constructor(private dataProvidersResolver: DataProvidersResolver) {}

  @Input()
  public set list({ provider, property }: IDynamicBindableValue) {
    const service = this.dataProvidersResolver.resolve(provider);

    if (!service) {
      return;
    }

    service
      .read<List>(property)
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.list$.next(value);
      });
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
